import React, { useState } from 'react';
import { Typography, Box, Modal } from '@mui/material';
import { useAppSelector } from '../../store/hooks';
import { metaDataSelector } from '../../store/globalSelectors';
import {
  BMRSection,
  BMRTitle,
  BMRValue
} from '../malnutritionScreening/glim/style';
import { TextWithInfoIcon } from '../../shared/components/textWithInfoIcon';
import { ToggleButtons } from './toggleButtons';
import { GridStyled } from './style';
import InfoIcon from '../../assets/icons/infoIcon.svg';
import { AddOnInfoModal } from '../../shared/components/modal/addOnInfoModal';

export const AdultEPF = () => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const { summary } = useAppSelector(metaDataSelector);

  return (
    <>
      <GridStyled
        className="width-100"
        id="section-A"
        container
        sx={{ background: '#004F71', paddingBottom: '0px', marginTop: '0px' }}
      >
        <Box
          sx={{ background: '#004F71', textAlign: 'center' }}
          className="pi-16"
        >
          <Typography
            sx={{
              fontSize: '1.125rem',
              lineHeight: '1.5rem',
              fontFamily: 'BGBold',
              fontWeight: '450',
              textTransform: 'uppercase',
              color: '#fff'
            }}
          >
            Estimated Nutritional Requirements
          </Typography>
        </Box>
        <BMRSection
          sx={{
            margin: '0px 1.875rem',
            flexDirection: 'column',
            alignItems: 'stretch',
            height: 'auto'
          }}
        >
          <TextWithInfoIcon
            data-testid={'adultPopupButton'}
            title={'Energy (kcal/day):'}
            icon={InfoIcon}
            fontSize={'1.5rem'}
            lineHeight={'1.375rem'}
            variant={'h4'}
            handleIconClick={() => handleOpen()}
            textAlign={'left'}
          />
          <ToggleButtons name={'ADULT_ENERGY'} />
        </BMRSection>
      </GridStyled>

      <>
        <GridStyled
          className="width-100"
          id="section-B"
          container
          sx={{ background: '#004F71', margin: '0px' }}
        >
          <BMRSection
            sx={{
              margin: '0px 1.875rem',
              display: 'flex',
              justifyContent: 'space-between'
            }}
          >
            <BMRTitle variant="h2" sx={{ width: '50%' }}>
              {'Protein (g):'}
            </BMRTitle>
            <BMRValue>{`${summary.estimatingRequirements.protein.min} - ${summary.estimatingRequirements.protein.max}`}</BMRValue>
          </BMRSection>
          <BMRSection sx={{ margin: '0px 1.875rem' }}>
            <BMRTitle variant="h2">{'Fluid (mL):'}</BMRTitle>
            <BMRValue>{summary.estimatingRequirements.fluids}</BMRValue>
          </BMRSection>
        </GridStyled>
      </>
      {/* <InfoModal
        open={open}
        onClose={handleClose}
        title={` `}
        content={`To compare the patient's requirements to our nutritional products,  please select one of the following estimated energy requirement results`}
      /> */}
      <Modal
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <AddOnInfoModal
          heading1={`PENG`}
          description1={` = Parenteral Enteral Nutrition Group`}
          title={` `}
          content={`To compare the patient's requirements to our nutritional products,  please select one of the following estimated energy requirement results`}
          onClose={handleClose}
        />
      </Modal>
    </>
  );
};
